import axios from 'axios'

export const sendApiRequest = async (urlPart, data = {}, method = 'get', options = {}) => {
  // Content is served as static JSON from /data (the Strapi API was retired
  // when the site moved hosting). "scrollers/abc" -> /data/scrollers-abc.json
  const url = `/data/${urlPart.replace('/', '-')}.json`;

  try {
    const response = await axios({
      method,
      url,
      data,
      ...options
    });

    return {
      status: 'success',
      data: response.data
    };
  } catch (error) {
    const err = {
      status: 'failure'
    };

    if (error.response) {
      const { data: { error: responseError } = {} } = error.response;

      if (responseError?.details?.messages) {
        err.formMessages = responseError.details.messages;
      }

      if (responseError) {
        err.data = responseError;
      }
    }

    return err;
  }
};